<template>
	<div class="d-flex">
		<div>
			<b-form-select
				v-model="hour"
				:options="hourOptions"
				:disabled="disabled"
				class="w-auto"
				@input="emitChangeEvent"
			/>
		</div>
		<div class="ml-2">
			<b-form-select
				v-model="minute"
				:options="minuteOptions"
				:disabled="disabled"
				class="w-auto"
				@input="emitChangeEvent"
			/>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import {isDefined} from "@/helper/Value";

export default {

	props: {
		value: {
			type: Object,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		focusHour: {
			type: Number,
			required: false,
		}
	},

	data ()
	{
		let hourOptions = [];

		if (this.focusHour)
		{
			hourOptions = _.map(
				_.range(this.focusHour, 23),
				hour =>
				{
					return {value: hour, text: _.padStart(hour.toString(), 2, '0')};
				}
			);

			_.forEach(_.range(0, this.focusHour - 1), hour =>
			{
				hourOptions.push({
					value: hour, text: _.padStart(hour.toString(), 2, '0')
				});
			})
		}
		else
		{
			hourOptions = _.map(
				_.range(0, 23),
				hour =>
				{
					return {value: hour, text: _.padStart(hour.toString(), 2, '0')};
				}
			);
		}

		return {
			hour: this.value ? this.value.hour : null,
			minute: this.value ? this.value.minute : null,
			hourOptions: Object.freeze(hourOptions),
			minuteOptions: Object.freeze([
				{ value: 0, text: '00' },
				{ value: 15, text: '15' },
				{ value: 30, text: '30' },
				{ value: 45, text: '45' },
			]),
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (isDefined(this.hour) && isDefined(this.minute))
			{
				this.$emit('input', {
					hour: this.hour,
					minute: this.minute,
				});

				return;
			}

			this.$emit('input', undefined);
		},
	},
}
</script>
